export const CUSTOM_DESIGN_REFERENCE_GUIDE_ASSET =
  '/marketing-material/MARKETING_MATERIAL_CUSTOM_DESIGN_REFERENCE_GUIDE.png';

export const CUSTOM_DESIGN_REFERENCE_GUIDE_URL =
  'https://d1ldwnjkukjs70.cloudfront.net/marketing_material_flyer_template_guide.png';
export const CUSTOM_DESIGN_REFERENCE_GUIDE_FILENAME =
  'waldo-flyer-template-guide.png';

// Expected design dimensions (8.5" x 11" portrait).
export const CUSTOM_DESIGN_ASPECT_RATIO = 8.5 / 11;
export const CUSTOM_DESIGN_ASPECT_RATIO_TOLERANCE = 0.05;

/**
 * Position of the keep-empty QR/instructions zone, as percentages of the
 * design canvas, matching the fixed area on the reference guide. Used to
 * overlay the zone on the uploaded design preview.
 */
export const CUSTOM_DESIGN_QR_ZONE = {
  left: '56.5%',
  top: '53%',
  width: '35.5%',
  height: '47.5%',
};
